import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  Button,
  Radio,
  RadioGroup,
  Row,
  Col,
  ControlLabel,
  CheckboxGroup,
  Checkbox,
  DatePicker,
  Message,
  Input,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { DATE_FORMAT, DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import { isEmpty } from 'lodash-es'
import {
  getTerminateProjectFileStaff,
  saveTerminateProjectFileStaff,
  updateTerminateProjectFileNameStaff,
  downloadTerminateProjectFileStaff,
  deleteTerminateProjectFileStaff,
  updateTerminateProjectStaffForm,
} from '../../redux/actions/endOfProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function EndOfProjectStaffWidget({
  schema: _schema,
  onSuccess = () => {},
  ...props
}) {
  const { showCommandButton, isEditAll, isApprove, schemaEvaluate, evaluateDisabled } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [formSchemaEvaluate, setFormSchemaEvaluate] = useState(schemaEvaluate)
  const [closeTypeSelected, setCloseTypeSelected] = useState(_schema?.closeType?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [uploadError, setUploadError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [isErrorFileList, setIsErrorFileList] = useState(false)
  const [sendToGranteeVal, setSendToGranteeVal] = useState(false)

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(() => {
    if (formSchema?.actualPeriod?.actualStartDate && formSchema?.actualPeriod?.actualEndDate) {
      setStartDate(
        formSchema.actualPeriod.actualStartDate.value
          ? moment(formSchema.actualPeriod.actualStartDate.value).toDate()
          : ''
      )
      setEndDate(
        formSchema.actualPeriod.actualEndDate.value
          ? moment(formSchema.actualPeriod.actualEndDate.value).toDate()
          : ''
      )
      setValue(
        formSchema.actualPeriod.actualStartDate.name,
        formSchema.actualPeriod.actualStartDate.value
          ? moment(formSchema.actualPeriod.actualStartDate.value).toDate()
          : ''
      )
      setValue(
        formSchema.actualPeriod.actualEndDate.name,
        formSchema.actualPeriod.actualEndDate.value
          ? moment(formSchema.actualPeriod.actualEndDate.value).toDate()
          : ''
      )
    }
  }, [_schema])

  useEffect(() => {
    if (
      !formSchemaEvaluate.evaluateQuality.value ||
      formSchemaEvaluate.evaluateQuality.value?.length === 0
    ) {
      setValue(formSchemaEvaluate.dataSource.name)
    }
  }, [schemaEvaluate])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)
    console.log('formSchema', formSchema)

    let request = {
      projectVersionId: projectId,
      value: data[formSchema.note.name] || '',
      approveType: isApprove ? data[formSchema.approveType.name] : 0,

      note: data[formSchema.note.name] || '',
      summaryOfWork: data[formSchema.summaryOfWork.name] || '',
      summaryOfBudget: data[formSchema.summaryOfBudget.name] || '',
      actualStartDate: data[formSchema.actualPeriod.actualStartDate.name]
        ? data[formSchema.actualPeriod.actualStartDate.name].toISOString()
        : '',
      actualEndDate: data[formSchema.actualPeriod.actualEndDate.name]
        ? data[formSchema.actualPeriod.actualEndDate.name].toISOString()
        : '',
      evaluateCompareGoal: data[formSchemaEvaluate.evaluateCompareGoal.name] || 0,
      evaluateQuality: data[formSchemaEvaluate.evaluateQuality.name] || 0,
      dataSource: data[formSchemaEvaluate.dataSource.name] || [],
      sendToGrantee: sendToGranteeVal,
      noteSendToGrantee: data?.noteSendToGrantee || '',
    }
    setRequest(request)
    console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateTerminateProjectStaffForm(projectId, request)
      console.log('response', response)
      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setIsError(e?.response?.data?.errors?.message)
      } else {
        setIsError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const handleCallUploadFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setUploadError()
    try {
      const response = await saveTerminateProjectFileStaff(projectId, request)
      console.log('response', response)
      setFormSchema((state) => {
        return {
          ...state,
          uploadDocuments: response,
        }
      })
      setUploadError(false)
      setIsErrorFileList(false)
    } catch (e) {
      console.log('e', e)
      setUploadError('อัปโหลดไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallDeleteFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setDeleteError(false)
    try {
      const response = await deleteTerminateProjectFileStaff(projectId, request.id)
      if (response == 200) {
        const res = await getTerminateProjectFileStaff(projectId)
        setFormSchema((state) => {
          return {
            ...state,
            uploadDocuments: res,
          }
        })
      }
    } catch (e) {
      setDeleteError('ลบไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallRenameFile = async (request) => {
    startLoading()
    setIsLoading(true)
    setRenameError()
    try {
      const response = await updateTerminateProjectFileNameStaff(projectId, request.id, request)
      setFormSchema((state) => {
        return {
          ...state,
          uploadDocuments: response,
        }
      })
      setRenameError(false)
    } catch (e) {
      setRenameError('แก้ไขชื่อไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    console.log('fileObj ', fileObj)
    try {
      const file = await downloadTerminateProjectFileStaff(projectId, fileObj.path)
      console.log('file ', file)
      previewFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await downloadTerminateProjectFileStaff(projectId, fileObj.path)
      downloadFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnClickUpload = (filesData) => {
    console.log('filesData', filesData)
    if (isEmpty(filesData?.attachFiles)) {
      return
    }
    const formData = new FormData()
    filesData?.attachFiles.forEach((element) => {
      formData.append('files', element.blobFile)
    })
    handleCallUploadFiles(formData)
  }

  const handleOnClickDelete = (fileIndex) => {
    if (!formSchema?.uploadDocuments.fileList?.value?.[fileIndex]?.id) {
      return
    }
    const request = {
      id: formSchema.uploadDocuments.fileList.value[fileIndex].id,
      fileName: formSchema.uploadDocuments.fileList.value[fileIndex].name,
    }
    handleCallDeleteFiles(request)
  }

  const handleOnClickRenameFile = (file, newName) => {
    if (!newName) {
      return
    }
    console.log('file', file)
    const request = {
      id: file.id,
      //name: newName,
      label: newName,
    }

    handleCallRenameFile(request)
  }

  return (
    <>
      <Panel shaded header={formSchemaEvaluate.header} eventKey={1} collapsible defaultExpanded>
        {formSchemaEvaluate.evaluateCompareGoal && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.evaluateCompareGoal.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.evaluateCompareGoal.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.evaluateCompareGoal.name]} />
            <Controller
              key={formSchemaEvaluate.evaluateCompareGoal.name}
              name={formSchemaEvaluate.evaluateCompareGoal.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.evaluateCompareGoal.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.evaluateCompareGoal.validators : null
              )}
              defaultValue={formSchemaEvaluate.evaluateCompareGoal.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchemaEvaluate.evaluateCompareGoal?.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
            <br />
          </>
        )}

        {formSchemaEvaluate.evaluateQuality && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.evaluateQuality.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.evaluateQuality.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.evaluateQuality.name]} />
            <Controller
              key={formSchemaEvaluate.evaluateQuality.name}
              name={formSchemaEvaluate.evaluateQuality.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.evaluateQuality.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.evaluateQuality.validators : null
              )}
              defaultValue={formSchemaEvaluate.evaluateQuality.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchemaEvaluate.evaluateQuality?.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
            <br />
          </>
        )}

        {formSchemaEvaluate.dataSource && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.dataSource.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.dataSource.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.dataSource.name]} />
            <Controller
              key={formSchemaEvaluate.dataSource.name}
              name={formSchemaEvaluate.dataSource.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.dataSource.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.dataSource.validators : null
              )}
              defaultValue={formSchemaEvaluate.dataSource.value}
              render={(props) => {
                return (
                  <CheckboxGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      if (value.length === 0) setValue(formSchemaEvaluate.dataSource.name)
                    }}
                  >
                    {formSchemaEvaluate.dataSource?.options?.map((item) => {
                      return (
                        <Checkbox value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Checkbox>
                      )
                    })}
                  </CheckboxGroup>
                )
              }}
            />
            <br />
          </>
        )}
      </Panel>

      <br />

      <Panel
        shaded
        header={formSchema.header}
        eventKey={2}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema?.note &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.note}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
              />
            </>
          ) : (
            <>
              <p>{formSchema.note.label}</p>
              <div
                style={{ wordWrap: 'break-word' }}
                dangerouslySetInnerHTML={{ __html: formSchema.note.value }}
              />
            </>
          ))}
        <br />
        {formSchema?.summaryOfWork &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.summaryOfWork}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
                notValidate={sendToGranteeVal ? true : false}
              />
            </>
          ) : (
            //)
            <>
              <p>{formSchema.summaryOfWork.label}</p>
              <div
                style={{ wordWrap: 'break-word' }}
                dangerouslySetInnerHTML={{ __html: formSchema.summaryOfWork.value }}
              />
            </>
          ))}
        <br />
        {formSchema?.summaryOfBudget &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.summaryOfBudget}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
                notValidate={sendToGranteeVal ? true : false}
              />
            </>
          ) : (
            <>
              <p>{formSchema.summaryOfBudget.label}</p>
              <div
                style={{ wordWrap: 'break-word' }}
                dangerouslySetInnerHTML={{ __html: formSchema.summaryOfBudget.value }}
              />
            </>
          ))}
        <br />
        {formSchema.closeDate && (
          <>
            {formSchema.closeDate.label}
            <br />
            <br />
          </>
        )}
        {formSchema.actualPeriod && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchema.actualPeriod.actualStartDate.validators) && 'required'
              )}
            >
              {formSchema.actualPeriod.header}
            </ControlLabel>

            {!showCommandButton ? (
              <p style={{ textIndent: '2.5em' }}>
                {new Date(formSchema.actualPeriod.actualStartDate.value).toLocaleDateString()} -{' '}
                {new Date(formSchema.actualPeriod.actualEndDate.value).toLocaleDateString()}
              </p>
            ) : (
              <Row>
                {formSchema.actualPeriod.actualStartDate && (
                  <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 210 }}>
                    <ErrorMessage error={errors[formSchema.actualPeriod.actualStartDate.name]} />
                    <Controller
                      key={formSchema.actualPeriod.actualStartDate.name}
                      name={formSchema.actualPeriod.actualStartDate.name}
                      control={control}
                      // rules={isValidators(formSchema.actualPeriod.actualStartDate.validators)}
                      rules={isValidators(
                        !sendToGranteeVal
                          ? formSchema.actualPeriod.actualStartDate.validators
                          : null
                      )}
                      defaultValue={startDate}
                      render={(props) => {
                        return (
                          <DatePicker
                            disabled={isEdit || !showCommandButton}
                            style={{ width: '100%' }}
                            format={DATE_PICKER_FORMAT}
                            placeholder={formSchema.actualPeriod.actualStartDate.label}
                            locale={LOCAL_DAY_TH}
                            // defaultValue={startDate}
                            value={startDate}
                            onChange={(value) => {
                              props.onChange(value)
                              setStartDate(value)
                              //setValue(formSchema.actualPeriod.actualStartDate.name, value)
                            }}
                            disabledDate={(date) =>
                              getValues(formSchema.actualPeriod.actualEndDate.name) &&
                              moment(
                                getValues(formSchema.actualPeriod.actualEndDate.name)
                              ).isBefore(date, new Date())
                            }
                          />
                        )
                      }}
                    />
                  </Col>
                )}

                {formSchema.actualPeriod.actualEndDate && (
                  <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 210 }}>
                    <ErrorMessage error={errors[formSchema.actualPeriod.actualEndDate.name]} />
                    <Controller
                      key={formSchema.actualPeriod.actualEndDate.name}
                      name={formSchema.actualPeriod.actualEndDate.name}
                      control={control}
                      // rules={isValidators(formSchema.actualPeriod.actualEndDate.validators)}
                      rules={isValidators(
                        !sendToGranteeVal ? formSchema.actualPeriod.actualEndDate.validators : null
                      )}
                      defaultValue={endDate}
                      render={(props) => {
                        return (
                          <DatePicker
                            disabled={isEdit}
                            style={{ width: '100%' }}
                            format={DATE_PICKER_FORMAT}
                            placeholder={formSchema.actualPeriod.actualEndDate.label}
                            locale={LOCAL_DAY_TH}
                            // defaultValue={endDate}
                            value={endDate}
                            onChange={(value) => {
                              props.onChange(value)
                              setEndDate(value)
                              //setValue(formSchema.actualPeriod.actualEndDate.name, value)
                            }}
                            disabledDate={(date) =>
                              getValues(formSchema.actualPeriod.actualStartDate.name) &&
                              moment(
                                getValues(formSchema.actualPeriod.actualStartDate.name)
                              ).isAfter(date, new Date())
                            }
                          />
                        )
                      }}
                    />
                  </Col>
                )}
              </Row>
            )}
            <br />
          </>
        )}
        {formSchema?.uploadDocuments &&
          (showCommandButton ? (
            <>
              <br />
              <p>{formSchema.uploadDocuments.header}</p>
              {isErrorFileList && <Message showIcon type="error" description={isErrorFileList} />}
              <AttachFilesForm
                schema={formSchema.uploadDocuments?.fileList}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                onSubmit={handleSubmit(handleOnClickUpload)}
                onDelete={handleOnClickDelete}
                onUpdate={handleOnClickRenameFile}
                onDownload={onDownload}
                onPreview={onPreview}
                isChangSeqNo={false}
                isEditErr={renameError}
                isUploadErr={uploadError}
                isDeleteError={deleteError}
                loading={isLoading}
              />
            </>
          ) : (
            <>
              <br />
              <p>{formSchema.uploadDocuments.header}</p>
              <AttachFilesView
                schema={formSchema.uploadDocuments?.fileList}
                onDownload={onDownload}
                onPreview={onPreview}
              />
            </>
          ))}
        {showCommandButton && (
          <Row style={{ marginTop: 20 }}>
            <Col xs={24} sm={24} md={24} lg={24}>
              {!formSchema.approveType && (
                <Checkbox
                  defaultChecked={sendToGranteeVal}
                  onChange={(_, checked, e) => {
                    console.log('checked ', checked)
                    setSendToGranteeVal(checked)
                  }}
                >
                  {formSchema?.sendToGrantee?.label}
                </Checkbox>
              )}

              {sendToGranteeVal && (
                <>
                  <ControlLabel
                    className={classNames(
                      'style-text-lable',
                      isRequired(formSchema.noteSendToGrantee.validators) && 'required'
                    )}
                  >
                    {formSchema.noteSendToGrantee.label}
                  </ControlLabel>

                  <ErrorMessage error={errors[formSchema.noteSendToGrantee.name]} />
                  <Input
                    name={formSchema.noteSendToGrantee.name}
                    inputRef={register(isValidators(formSchema.noteSendToGrantee.validators))}
                    rows={3}
                    placeholder={formSchema.noteSendToGrantee.hint}
                    componentClass="textarea"
                    defaultValue={formSchema.noteSendToGrantee.value}
                    disabled={formSchema.noteSendToGrantee.disabled}
                  />
                </>
              )}
            </Col>
          </Row>
        )}
        {showCommandButton && (
          <>
            <hr />

            {isError && <Message showIcon type="error" description={isError} />}

            {/* <Button ripple appearance="ghost" onClick={handleSubmit(onSubmit)}>
              {formSchema.buttonText}
            </Button> */}
            <Row>
              {sendToGranteeVal ? (
                <SaveButton
                  onClick={handleSubmit(onSubmit)}
                  disabled={!sendToGranteeVal}
                  icon="send-o"
                >
                  {formSchema?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'}
                </SaveButton>
              ) : (
                <ApproverList
                  approveType={8}
                  projectversionId={projectId}
                  style={{
                    marginRight: 10,
                    marginBottom: 10,
                  }}
                  buttontext={'ตรวจสอบสายอนุมัติและ' + formSchema.buttonText}
                  isLoading={isLoading}
                  fetchButton={(disabled) =>
                    <SaveButton
                      style={{
                        marginBottom: 10,
                      }}
                      icon="send"
                      onClick={handleSubmit(onSubmit)}
                      disabled={disabled || isLoading}
                    >
                      {sendToGranteeVal
                        ? formSchema?.sendToGrantee?.buttonText
                        : formSchema.buttonText}
                    </SaveButton>
                  }
                />
              )}
            </Row>
          </>
        )}

        {formSchema?.checkButton && (
          <ApproverList
            approveType={8}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={formSchema?.checkButton}
            isLoading={isLoading}
            fetchButton={(disabled) =>
              formSchema?.fetchButton && (
                <FetchNewApprover
                  approveType={8}
                  projectversionId={projectId}
                  style={{ marginRight: 10, marginBottom: 10}}
                  buttontext={formSchema?.fetchButton}
                  onSuccess={onSuccess}
                  disabled={disabled}
                />
              )
            }
            // contractModifyType={contractModifyType}
          />
        )}
        {formSchema?.cancelButton && (
          <CancelApprovalList
            approveType={8}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={formSchema?.cancelButton}
            onSuccess={onSuccess}
          />
        )}

        <ConfirmWidget
          title={`ยืนยันการ${
            sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText
          }`}
          // confirmBtn={`ยืนยัน${formSchema.buttonText}`}
          // cancleBtn={`ยกเลิก${formSchema.buttonText}`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการ${
            sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText
          }`}
          onCancle={onCancle}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}
